module.exports = __webpack_public_path__ + "img/notifi-warn.37ab1f34.svg";